export class UpdateSapSourceInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "shortName",
            "baseName": "shortName",
            "type": "string",
            "format": ""
        },
        {
            "name": "selectedObjects",
            "baseName": "selectedObjects",
            "type": "Array<SapObjectSelection>",
            "format": ""
        },
        {
            "name": "scheduleStart",
            "baseName": "scheduleStart",
            "type": "SapScheduleStart",
            "format": ""
        },
        {
            "name": "cdcPollingSeconds",
            "baseName": "cdcPollingSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertCdcLagMinutes",
            "baseName": "alertCdcLagMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertErrorRatePct",
            "baseName": "alertErrorRatePct",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertAgentOfflineMinutes",
            "baseName": "alertAgentOfflineMinutes",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSapSourceInput.attributeTypeMap;
    }
    constructor() {
    }
}
